import styled from "@emotion/styled";
import { applyCmsImageParams } from "@9amhealth/cms-api";
import type { FC } from "react";
import { useMemo } from "react";
import type { SimpleCmsImageData } from "src/types/sanitySchema";
import { useSanityAssets } from "src/ui/components/SanityBlockContent/useSanityAssets";

const LOGO_ROW_HEIGHT_PX = 55;
// 2x the row height so retina displays render crisply; width unconstrained
// because logos have varying aspect ratios.
const LOGO_IMAGE_HEIGHT_PX = LOGO_ROW_HEIGHT_PX * 2;

const List = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 15px;
  grid-auto-rows: ${LOGO_ROW_HEIGHT_PX}px;
`;

const Logo = styled.div`
  background: white;
  box-shadow: 0 0 7px rgba(0, 0, 0, 0.15);
  padding: 3px 5px;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    max-height: 100%;
    max-width: 100%;
    border-radius: unset;
  }
`;

interface Props {
  images: SimpleCmsImageData[];
}

const ImageList: FC<Props> = ({ images }) => {
  const refs = useMemo(() => images.map((image) => image.asset._ref), [images]);
  const assets = useSanityAssets(refs);

  return (
    <List>
      {assets.map((image) => (
        <Logo key={image._id}>
          <img
            src={applyCmsImageParams(image.url, {
              height: LOGO_IMAGE_HEIGHT_PX,
              autoFormat: true
            })}
            alt={image.originalFilename}
          />
        </Logo>
      ))}
    </List>
  );
};

export default ImageList;
